export default __webpack_public_path__ + "b7e409c513db8b53e41aaa80b59d7968.svg";